module.exports = __webpack_public_path__ + "jpg/ruStore.jpg?d95256a7aafb6115b497353c098d517b";